module.exports = __webpack_public_path__ + "static/media/gs.7b917516.svg";